module.exports = __webpack_public_path__ + "static/media/blue.b7c347ba.png";